import React from 'react';
import {NeuroMessage} from '@ignitesales/neuro-application';
import {MessagePropTypes} from "../utils/propTypes.mjs";

const SummaryPageTitle = ({ tagName = 'h1' }) => {
    return ( <NeuroMessage id='summary.title' tagName={tagName} /> );
};
SummaryPageTitle.propTypes = MessagePropTypes;

const SummaryPageSubtitle = ({ tagName = 'p' }) => {
    return ( <NeuroMessage id='summary.subtext' tagName={tagName} shouldHideIfNotFound={true} /> );
};
SummaryPageSubtitle.propTypes = MessagePropTypes;

export {
    SummaryPageTitle,
    SummaryPageSubtitle
};
